import moment from 'moment-timezone';

export const initialValues = {
    step0: {
        isCompleted: false,
        zone: '',
        ballParcZoneId: '',
        ownerName: '',
        monthlyDueDate: '',
        longitude: '',
        latitude: '',
        capacity: '',
        locationType: '',
        market: '',
        image: '',
        addressType: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        isAccessCodeRequired: true,
        isSaleTaxRequired: true
    },
    step1: {
        isCompleted: false,
        hourlyRates: [
            {
                rateName: '',
                rateDurations: [],
                availableDays: [],
                availableHours: {},
                rateLimit: '',
                ratePrice: '',
                rateIcon: ''
            }
        ],
        // recurringRates: [
        //     {
        //         recurringRateName: '',
        //         recurringRateDuration: '',
        //         recurringActiveDays: [],
        //         recurringAvailableHours: [],
        //         recurringRateLimit: '',
        //         recurringRatePrice: '',
        //         recurringRateIcon: '',
        //         feeName: '',
        //         feePrice: '',
        //         feePercentage: '',
        //         feeChannel: ''
        //     }
        // ],
        recurringRates: [
            {
                frequency: '', // Weekly, Monthly, Quarterly, Annually
                rate: '', // The cost of the recurring rate
                validParkingDays: [], // Days for which the rate is valid
                validParkingTime: { startTime: '', endTime: '' }, // Time range for parking
                rateName: '', // Name of the recurring rate
                isPublic: false, // Boolean for public visibility
                isVip: false
            }
        ],
        fees: [
            {
                feeName: '',
                feePrice: '',
                feeChannel: '',
                isFixedPrice: false
            }
        ]
    },
    step2: {
        isCompleted: false,
        features: []
    }
};

export const groupInitialValues = {
    step0: {
        isCompleted: false,
        groupName: '',
        streetAddress: '',
        streetAddress2: '',
        city: '',
        state: '',
        zipCode: '',
        firstName: '',
        lastName: '',
        title: '',
        email: '',
        phoneNumber: '',
        notifications: false
    },
    step1: {
        isCompleted: false,
        subscriptions: [
            {
                zone: '',
                subscription: '',
                specialRate: '',
                parkerMinimum: 0,
                parkerMaximum: ''
            }
        ],
        validations: [
            {
                zoneValidation: '',
                discount: '',
                maximumDuration: '',
                isFixedPrice: false, // 🔹 Added this property to handle $ or %
                monthlyMaximum: 0,
                isHourlyMaximumDuration: false
            }
        ]
    },
    step2: {
        isCompleted: false,
        autoPay: false,
        invoicing: true,
        netTerms: '',
        processingFee: ''
    }
};
